import Vue from 'vue'
import Router from 'vue-router'
import routers from './router'
// import storage from '../utils/storage.js';
// import api from '@/api/index.js'
// import AES from "@/utils/AES.js"
Vue.use(Router);
const RouterConfig = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: routers
};
const router = new Router(RouterConfig);

//路由守卫，路由拦截器
router.beforeEach((to, from, next) => {
  if (!to.matched || to.matched.length === 0) {
    console.log('1')
  } else {
    next();
  }
})
export default router;
